import { format } from 'date-fns';
import { IDateVariants } from '@atoms/Datepicker/DatepickerCalendar/datepicker.types';

const dateToISODate = (date: Date) => format(date, 'yyyy-MM-dd');
const dateToISODateTimeNoZ = (date: Date | undefined) => (date && format(date, "yyyy-MM-dd'T'HH:mm:ss.00")) || '';

/**
 * Преобразует строковую дату в формату в структуру IDateVariant.
 *
 * @param date Дата в формате ГГГГ-ММ-ДД
 */
const fromISODateToIDateVariant = (date: string): IDateVariants => {
    const dateObj = new Date(date);
    const inUnixTime = dateObj.getTime();
    const unixTimeValues = {
        from: inUnixTime,
        value: inUnixTime,
        to: inUnixTime,
    };

    // Инвертируем порядок даты с YYYY-MM-DD на DD-MM-YYYY для компонента DatePicker
    const reversedDateString = dateToISODate(dateObj).split('-').reverse().join('-');

    return {
        date: {
            from: dateObj,
            value: dateObj,
            to: dateObj,
            utc: dateObj,
        },
        value: reversedDateString,
        timestamp: {
            utc: unixTimeValues,
            ...unixTimeValues,
        },
    };
};

const isDateInArray = (array: Date[], value: Date) => {
    return !!array.find((item) => {
        return item.getTime() === value.getTime();
    });
};

export function stringifyDates<T>(value: T): T {
    if (value == null) return value;

    if (value instanceof Date) {
        return value.toISOString() as unknown as T;
    }

    if (Array.isArray(value)) {
        return value.map((v) => stringifyDates(v)) as unknown as T;
    }

    if (typeof value === 'object') {
        const result: any = {};
        for (const [key, val] of Object.entries(value as any)) {
            result[key] = stringifyDates(val);
        }
        return result;
    }

    return value;
}

export { dateToISODate, dateToISODateTimeNoZ, fromISODateToIDateVariant, isDateInArray };
